<template>
    <div v-if="queue.length > 0" :class="['fm-upload-card', {'fm-upload-card--minimized': minimized}]">
        <div class="fm-upload-card-header" @click="minimized = !minimized">
            <span class="fm-upload-card-title">
                <template v-if="allDone">{{ $t('common.fileManager.uploadDone', {count: totalFiles}) }}</template>
                <template v-else>{{ $t('common.fileManager.uploadProgress', {done: doneCount, total: totalFiles}) }}</template>
            </span>
            <svg :class="['fm-upload-card-chevron', {'fm-upload-card-chevron--up': !minimized}]"
                 viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>
        </div>
        <div v-if="!minimized" class="fm-upload-card-body">
            <div v-for="item in queue" :key="item.id" class="fm-upload-card-file">
                <div class="fm-upload-card-file-top">
                    <span v-if="item.status === 'done'" class="fm-upload-card-check">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
                    </span>
                    <span class="fm-upload-card-filename">{{ fileNames(item) }}</span>
                    <span class="fm-upload-card-percent">{{ item.status === 'done' ? '100%' : item.progress + '%' }}</span>
                </div>
                <div class="fm-upload-card-bar">
                    <div class="fm-upload-card-bar-fill" :class="{'fm-upload-card-bar-fill--done': item.status === 'done'}"
                         :style="{width: item.progress + '%'}"></div>
                </div>
                <div v-if="item.status !== 'done'" class="fm-upload-card-stats">
                    <span>{{ formatSpeed(item.speed) }}</span>
                    <span>{{ formatEta(item.eta) }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import fileManagerService from './fileManagerService'

export default {
    name: 'FileManagerUploadProgress',
    data() {
        return {
            minimized: false,
        }
    },
    computed: {
        queue() {
            return fileManagerService.state.uploadQueue
        },
        totalFiles() {
            let count = 0
            this.queue.forEach(q => { count += q.files.length })
            return count
        },
        doneCount() {
            let count = 0
            this.queue.forEach(q => { if (q.status === 'done') count += q.files.length })
            return count
        },
        allDone() {
            return this.queue.length > 0 && this.queue.every(q => q.status === 'done')
        },
    },
    methods: {
        fileNames(item) {
            if (item.files.length === 1) return item.files[0].name
            return this.$t('common.fileManager.uploadFileCount', {count: item.files.length})
        },
        formatSpeed(bytesPerSec) {
            if (!bytesPerSec || bytesPerSec <= 0) return ''
            if (bytesPerSec < 1024) return Math.round(bytesPerSec) + ' B/s'
            if (bytesPerSec < 1048576) return (bytesPerSec / 1024).toFixed(1) + ' KB/s'
            return (bytesPerSec / 1048576).toFixed(1) + ' MB/s'
        },
        formatEta(seconds) {
            if (!seconds || seconds <= 0) return ''
            if (seconds < 60) return this.$t('common.fileManager.etaSeconds', {n: Math.ceil(seconds)})
            if (seconds < 3600) return this.$t('common.fileManager.etaMinutes', {n: Math.ceil(seconds / 60)})
            return this.$t('common.fileManager.etaHours', {n: Math.floor(seconds / 3600)})
        },
    },
}
</script>
